export default {"src":"__ASTRO_ASSET_IMAGE__FdSHdeOr__","width":41,"height":41,"format":"png"}